/**
 * 服务
 */
import http from '../http'
import Qs from 'qs'

// 登录
// const handelLogin = (params) => http.post('/login', Qs.stringify(params)).then(res => res.data);

// 服务订单列表
const getorgOrderPage = (params) =>
  http.get('/userOrder/orgOrderPage', { params }).then((res) => res.data)
// 机构查询改价记录
const adjustOrdFeePage = (params) =>
  http
    .get('/userOrder/org/adjustOrdFeePage', { params })
    .then((res) => res.data)

// 运营端查询改价记录
const adjustOrdFeePageOperate = (params) =>
  http
    .get('/userOrder/sys/adjustOrdFeePage', { params })
    .then((res) => res.data)
// 订单退款
const orderRefund = (params) =>
  http
    .post('/userOrder/refund', Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data)
// 服务退款订单列表
const getorgRefundOrderPage = (params) =>
  http
    .get('/userOrder/orgRefundOrderPage', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
    .then((res) => res.data)
// 确认退款
const confirmRefund = (params) =>
  http({
    method: 'put',
    url: `/userOrder/confirmRefund`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 学生上课提醒
const stuRemind = (params) =>
  http.post('/sign/remind/stu', Qs.stringify(params)).then((res) => res.data)
// 教师上课提醒
const teaRemind = (params) =>
  http.post('/sign/remind/tea', Qs.stringify(params)).then((res) => res.data)

// 获取服务下的学校信息
const getorgSchool = (params) =>
  http.get('/schoolOrgRel/orgSchoolName', { params }).then((res) => res.data)
// 获取服务下所有学校的学生动态下拉列表接口
const getorgStudent = (params) =>
  http.get('/student/orgSchoolStudent', { params }).then((res) => res.data)
// （后台）查询学生列表接口(根据多个学校)
const queryListSchoolIds = (params) =>
  http.get('/student/queryListSchoolIds', { params }).then((res) => res.data)

// 获取教师管理列表接口
const getTeacherlist = (params) =>
  http.get('/teacher/queryList', { params }).then((res) => res.data)
// （批量）删除教师接口
const deleteTeacher = (params) =>
  http.delete('/teacher/delete', { params }).then((res) => res.data)
// const  = (params) =>http({method:'delete',url:'/teacher/delete', data:params,headers:{'Content-Type':'application/json;charset=UTF-8'}}).then(res => res.data);
// 新增教师
const addTeacher = (params) =>
  http({
    method: 'post',
    url: '/teacher/add',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 教师修改/新增密码接口
const changeTeachepass = (params) =>
  http({
    method: 'put',
    url: `/teacher/changePassword`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 修改教师接口
const updateTeacher = (params) =>
  http({
    method: 'put',
    url: `/teacher/update`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 服务课程列表
const getorgPage = (params) =>
  http.get('/courseDefine/orgPage', { params }).then((res) => res.data)
// 服务课程详情
const getorgPageDetail = (params) =>
  http.get('/courseDefine', { params }).then((res) => res.data)
// 新增课程
const addcourseDefine = (params) =>
  http({
    method: 'post',
    url: '/courseDefine',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 修改课程
const editCourseDefine = (params) =>
  http({
    method: 'put',
    url: `/courseDefine`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 发布课程
const putCourseDefine = (params) =>
  http({
    method: 'put',
    url: `/courseDefine/publish`,
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then((res) => res.data)
// 下架课程
const downCourseDefine = (params) =>
  http({
    method: 'put',
    url: `/courseDefine/check`,
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then((res) => res.data)
// 删除课程
const deleteCourseDefine = (params) =>
  http.delete('/courseDefine', { params }).then((res) => res.data)

// 年度学期列表
const getlistTerms = (params) =>
  http.get('/yearTerms/schoolTerms', { params }).then((res) => res.data)
// 根据服务id获取服务详情
const getsysOrganizationsName = (params) =>
  http.get('/sysOrganizations', { params }).then((res) => res.data)
// 服务课班列表
const getorgClassPage = (params) =>
  http.get('/courseClass/orgClassPage', { params }).then((res) => res.data)

// 添加课班-学校入围课程
const getschoolCheckCourseList = (params) =>
  http
    .get('/courseDefine/schoolCheckCourseList', { params })
    .then((res) => res.data)
// 查询学校或服务所有教师动态下拉列表接口
const getDynamicListorg = (params) =>
  http.get('/teacher/DynamicList', { params }).then((res) => res.data)
// 查询学校场地动态下拉列表接口
const getschoolPlaceListorg = (params) =>
  http.get('/sys/places/schoolPlaceList', { params }).then((res) => res.data)
// 查询上课时间
const getClassTime = (params) =>
  http.get('/courseClassPeriod/list', { params }).then((res) => res.data)
// 服务课班详情
const getclassDetail = (params) =>
  http.get('/courseClass', { params }).then((res) => res.data)
// 新增课班
const addcourseClass = (params) =>
  http({
    method: 'post',
    url: '/courseClass',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 修改课班
const editcourseClass = (params) =>
  http({
    method: 'put',
    url: `/courseClass`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 删除课班
const deletecourseClass = (params) =>
  http.delete('/courseClass', { params }).then((res) => res.data)
// 批量修改课班状态（确定，驳回，发布，取消发布）
const editclassroomState = (params) =>
  http({
    method: 'put',
    url: `/courseClass/classroomState`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 判断课班是否开课
const checkCourseState = (params) =>
  http.get('/courseClass/checkCourseState', { params }).then((res) => res.data)
// 教师考勤-教师考勤
const getschTea = (params) =>
  http.get('/sign/sch/tea', { params }).then((res) => res.data)
// 教师考勤-教师考勤-设置签到/签退时间
const editSclTea = (params) =>
  http({
    method: 'put',
    url: `/sign/sch/tea`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 课程表-课表数据(根据参数筛选)
const gettimetable = (params) =>
  http.get('/courseClass/timetable', { params }).then((res) => res.data)
// 删除课程表
const deleteTimetable = (params) =>
  http
    .delete('/courseClass/deleteTimetable', { params })
    .then((res) => res.data)
// 课程表-编辑/调课
const modifyTimetable = (params) =>
  http({
    method: 'post',
    url: '/courseClass/modifyTimetable',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 服务管理-添加或者修改服务微信商户信息
const editSysOrgWeixinAccts = (params) =>
  http({
    method: 'put',
    url: `/sysOrgWeixinAccts`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 学校管理-学校统计
const getStatSchool = (params) =>
  http.get('/stat/org/stat/school', { params }).then((res) => res.data)
// 学校管理-课程分类
const getStatCourseDefine = (params) =>
  http.get('/stat/org/stat/courseDefine', { params }).then((res) => res.data)
// 学校管理-课班出勤统计
const getStatCourseClassSign = (params) =>
  http
    .get('/stat/org/stat/courseClass/sign', { params })
    .then((res) => res.data)

// 通知管理-家校通知列表
const getqueryNotice = (params) =>
  http
    .get('/theUserIdentity/notice/queryNotice', { params })
    .then((res) => res.data)
// 通知管理-家校通知-审核通知
const editreviewNotice = (params) =>
  http({
    method: 'put',
    url: `/notice/reviewNotice`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 删除家校通知
const deleteNotice = (params) =>
  http.delete('/notice/deleteNotice', { params }).then((res) => res.data)
// 通知管理-家校通知-详情
const getqueryNoticeDetail = (params) =>
  http.get('/notice/queryNoticeDetail', { params }).then((res) => res.data)
// 通知管理-家校通知-详情-通知阅读详情接口
const getqueryNoticeReadDetail = (params) =>
  http.get('/notice/queryNoticeReadDetail', { params }).then((res) => res.data)
// 通知管理-家校通知-发布-学校列表
const getOrgSchoolName = (params) =>
  http.get('/schoolOrgRel/orgSchoolName', { params }).then((res) => res.data)
// 通知管理-家校通知-发布-学校列表-服务下面某学校所有课程学生
const getclassroomStudentForsch = (params) =>
  http
    .get('/classroomStudents/classroomStudent/org/school', { params })
    .then((res) => res.data)
// 新增家校通知
const addSclNotice = (params) =>
  http({
    method: 'post',
    url: '/notice/addNotice',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)
// 修改家校通知
const editupdateNotice = (params) =>
  http({
    method: 'put',
    url: `/notice/updateNotice`,
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 学生报名 (课班) 统计
const getstuEnroll = (params) =>
  http.get('/course/stat/stuEnroll', { params }).then((res) => res.data)
// (PC)学校端 - 课程报名- 学生报名删除
// const deletestuEnroll = (params) => http.delete('/course/stuEnroll',{params}).then(res => res.data);
const deletestuEnroll = (params) =>
  http({
    method: 'delete',
    url: `/course/stuEnroll`,
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then((res) => res.data)
// (PC)学生个人课表
const getstutimeData = (params) =>
  http.get('/course/week/course', { params }).then((res) => res.data)

// 课程报名统计(服务端) -报班管理情况
const getClassEnrollByOrg = (params) =>
  http.get('/courseClass/org/class/enroll', { params }).then((res) => res.data)

// 课程报名统计(服务端) - 报班课程介绍
const getClassMienDetailByOrg = (params) =>
  http.get('/course/org/mien/detail', { params }).then((res) => res.data)

// 课程考勤统计列表(机构端)
const getAttendanceList = (params) =>
  http
    .get('/courseClass/org/class/sign/total', { params })
    .then((res) => res.data)

// 课程考勤统计列表(学校端)
const getAttendanceListSchool = (params) =>
  http.get('/courseClass/class/sign/total', { params }).then((res) => res.data)

// 机构- 数据概览
const getOrgsBasicData = (params) =>
  http.get('/stat/org/view/org/basicData', { params }).then((res) => res.data)

// 机构 - 营收统计
const getOrgsRevenueData = (params) =>
  http.get('/stat/org/view/revenue', { params }).then((res) => res.data)

// 机构- 最受欢迎课班/托管TOP5
const getOrgsTop5Data = (params) =>
  http.get('/stat/org/view/org/top5', { params }).then((res) => res.data)

// 机构  - 机构订餐统计
const getOrgsFoodData = (params) =>
  http.get('/stat/org/org/food', { params }).then((res) => res.data)

// 机构 - 托管概览
const getOrgsTuoguanData = (params) =>
  http.get('/stat/org/view/org/tuoguan', { params }).then((res) => res.data)

// 机构 - 课程概览
const getOrgsCourseTypeData = (params) =>
  http.get('/stat/org/view/org/courseType', { params }).then((res) => res.data)

// 机构 -学校 - 数据概览
const getOrgSchBasicData = (params) =>
  http
    .get('/stat/org/view/org/sch/basicData', { params })
    .then((res) => res.data)

// 机构 -学校- 最受欢迎课班/托管TOP5
const getOrgSchTop5Data = (params) =>
  http.get('/stat/org/view/org/sch/top5', { params }).then((res) => res.data)

// 机构 -学校 - 学校订餐统计
const getOrgSchFoodData = (params) =>
  http.get('/stat/org/org/sch/food', { params }).then((res) => res.data)

// 机构 -学校 - 托管概览
const getOrgSchTuoguanData = (params) =>
  http.get('/stat/org/view/org/sch/tuoguan', { params }).then((res) => res.data)

// 机构 -学校 - 课程概览
const getOrgSchCourseTypeData = (params) =>
  http
    .get('/stat/org/view/org/sch/courseType', { params })
    .then((res) => res.data)
// 判断是否有商户信息
const judgeMerchantInfo = (params) =>
  http
    .get('/sysOrganizations/merchantIsAvailable', { params })
    .then((res) => res.data)

// 撤回分账
const cancelWithdraw = (params) =>
  http
    .post(`/fund/withdraw`, Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data)

// 机构调整订单价格
const adjustPrice = (params) =>
  http({
    method: 'post',
    url: '/userOrder/org/adjustOrdFee',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 运营调整订单价格
const adjustPriceOperate = (params) =>
  http({
    method: 'post',
    url: '/userOrder/sys/adjustOrdFee',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data)

// 获取机构下面的学校
const getOrgSchoolListNew = (params) =>
  http
    .get('/schoolOrgRel/pageOrgSchoolName', { params })
    .then((res) => res.data)

export default {
  getorgOrderPage,
  getorgSchool,
  getorgStudent,
  getTeacherlist,
  deleteTeacher,
  addTeacher,
  changeTeachepass,
  updateTeacher,
  editCourseDefine,
  addcourseDefine,
  putCourseDefine,
  deleteCourseDefine,
  getorgPage,
  getorgPageDetail,
  downCourseDefine,
  getlistTerms,
  getorgClassPage,
  getschoolCheckCourseList,
  getDynamicListorg,
  getschoolPlaceListorg,
  getClassTime,
  addcourseClass,
  editcourseClass,
  deletecourseClass,
  editclassroomState,
  checkCourseState,
  getclassDetail,
  getschTea,
  editSclTea,
  gettimetable,
  editSysOrgWeixinAccts,
  deleteTimetable,
  modifyTimetable,
  getqueryNotice,
  getsysOrganizationsName,
  deleteNotice,
  getqueryNoticeDetail,
  getqueryNoticeReadDetail,
  editreviewNotice,
  getstuEnroll,
  deletestuEnroll,
  getstutimeData,
  getClassEnrollByOrg,
  getClassMienDetailByOrg,
  orderRefund,
  getorgRefundOrderPage,
  getOrgSchoolName,
  getclassroomStudentForsch,
  addSclNotice,
  editupdateNotice,
  confirmRefund,
  getStatSchool,
  getStatCourseDefine,
  getStatCourseClassSign,
  stuRemind,
  teaRemind,
  queryListSchoolIds,
  getAttendanceList,
  getAttendanceListSchool,
  getOrgsBasicData,
  getOrgsRevenueData,
  getOrgsTop5Data,
  getOrgsFoodData,
  getOrgsTuoguanData,
  getOrgsCourseTypeData,
  getOrgSchBasicData,
  getOrgSchTop5Data,
  getOrgSchFoodData,
  getOrgSchTuoguanData,
  getOrgSchCourseTypeData,
  judgeMerchantInfo,
  cancelWithdraw,
  adjustOrdFeePage,
  adjustOrdFeePageOperate,
  adjustPrice,
  getOrgSchoolListNew,
  adjustPriceOperate
}
